import { memo } from "react";
import OwnerMilkrecordingSelect from "../../components/multiforms/OwnerMilkrecordingSelect";

const SelectAnimalMilkRecording = () => {
    return (
        <OwnerMilkrecordingSelect type={"SelectAnimalMilkRecording"} />
    )
}

export default memo(SelectAnimalMilkRecording);